'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnavailableData = function UnavailableData(props) {
  var iconName = props.iconName,
      iconColor = props.iconColor,
      content = props.content;

  return _react2.default.createElement(_semanticUiReact.Popup, {
    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: iconName, color: iconColor }),
    content: content
  });
};

UnavailableData.propTypes = {
  iconName: _propTypes2.default.string.isRequired,
  iconColor: _propTypes2.default.string.isRequired,
  content: _propTypes2.default.string.isRequired
};

exports.default = UnavailableData;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/unavailable-data/index.js
 ** module id = 2598
 ** module chunks = 0
 **/